<template>
  <div class="sidebar left fixed responsive xlarge-down no-transition" id="profile">
    <div class="fixed-container">
      <!-- Profile -->
      <div class="sidebar-profile-intro">
        <span class="avatar large icon profile">
          <svg width="80px" height="80px" viewBox="0 0 80 80"><use xlink:href="/static/sprites.svg#user-avatar-glyph-large"></use></svg>
        </span>

        <h4>{{bruker.full_name}}</h4>
        <span class="profile-user-title">Brukernavn: {{bruker.Brukernavn}}</span>
      </div>

      <!-- Tabs -->
      <div class="tabs fluid" id="sidebar-tabs">
        <ul>
          <li v-for="(tabItem, key) in tabs" :key="key" :class="{'active': key === selectedTab}">
            <a href="javascript:;" @click="tab(key)">{{ tabItem.name }}</a>
          </li>
        </ul>
      </div>

      <!-- Content -->
      <div class="sidebar-content-container" id="sidebar-tab-content" v-if="selectedTabComponent">
        <component v-bind:is="selectedTabComponent" v-bind="{bruker: bruker}"></component>
      </div>
    </div>

    <a href="javascript:;" @click="hideProfileSidebar()" class="sidebar-overlay"></a>
  </div>
</template>

<script>

// import TabLogg from './BrukerCardSidebarTabLogg'
import TabProfile from './BrukerCardSidebarTabProfile'

export default {
  name: 'BrukerCardSidebar',
  props: {
    bruker: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      tabs: {
        'profile': {name: 'Profil', component: TabProfile}
        // 'logg': {name: 'Historikk', component: TabLogg}
      },
      selectedTab: '',
      selectedTabComponent: null
    }
  },
  mounted () {
    // Load tab from localstorage or default
    let tab = localStorage.bcp_tab || 'profile'

    this.tab(tab)
  },
  methods: {
    tab: function (tab) {
      if (this.tabs.hasOwnProperty(tab)) {
        // Save to localstorage - to remember
        localStorage.bcp_tab = tab

        this.selectedTab = tab
        this.selectedTabComponent = this.tabs[tab].component
      }
    },
    hideProfileSidebar: function () {
      this.$helpers.toggleSidebar('profile')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/BrukerCardSidebar.vue